import React from 'react'
import { Network } from '@teschglobal/tg-fhir-react-components'
import type { Organization as FHIROrganization } from '@teschglobal/tg-fhir-react-components/dist/types'
import useFhirConfig from '../../../../../hooks/admin/useFhirConfig'

type NetworkDetailProps = {
    networks: FHIROrganization | null
}

const NetworkDetail: React.FC<NetworkDetailProps> = ({ networks }) => {
    const { providerDirectoryFhirConfig, handleSelectOrganization } = useFhirConfig()

    if (!networks) {
        return (
            <div className="text-center" role="status" aria-live="polite" aria-atomic="true">
                Not Found
            </div>
        )
    }

    return (
        <section>
            <h3>Network</h3>
            <Network
                data={networks}
                fhirApiConfig={providerDirectoryFhirConfig}
                onSelectOrganization={handleSelectOrganization}
            />
        </section>
    )
}

export default NetworkDetail